import { useTranslation } from "react-i18next";
import { Chip, TableCell } from "@mui/material";

import { CategoryCellProps } from "../../../../payment.types";

export const CategoryCell = ({ category }: CategoryCellProps) => {
  const { t } = useTranslation();

  return (
    <TableCell
      sx={{
        textAlign: "center",
        fontFamily: "Montserrat",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "18px",
      }}
    >
      <Chip
        label={t(`pages.payment.paymentLinks.${category}`)}
        sx={{
          height: "22px",
          background: "transparent",
          "& .MuiChip-label": {
            padding: "0 8px",
            background:
              category === "MEMBERSHIP"
                ? "var(--Success-50, #ECFDF3)"
                : category === "PRODUCT"
                ? "var(--Blue-50, #EFF8FF)"
                : "var(--Pink-50, #FDF2FA)",
            color:
              category === "MEMBERSHIP"
                ? "var(--Success-700, #027A48)"
                : category === "PRODUCT"
                ? "var(--Blue-700, #175CD3)"
                : "var(--Pink-700, #C11574)",

            borderRadius: "16px",
            border: "none",
          },
        }}
      />
    </TableCell>
  );
};
